import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { TestTypeProgram } from '../../../../constants';
import PrismicRichText from '../../../Base/PrismicRichText';

import './styles.scss';

const SessionDesc = ({ desc, program }) => {
  const { t } = useTranslation();

  return (
    <div className={'account-session-desc'}>
      <strong>
        {program === TestTypeProgram.PP ? t('account.session.testtype-pp') : t('account.session.testtype-ip')}
      </strong>{' '}
      <PrismicRichText richText={desc} onlyText={true} />
    </div>
  );
};

SessionDesc._propTypes = {
  program: PropTypes.string,
  desc: PropTypes.array,
};

export default SessionDesc;
